import { CacheKeyType } from "../domainObjects/transformType";

export class ExportViewModel {
  refineryConfigID= '';
  nodeId= '';
  transformerID= '';
  fileDelimiter = '';
  fileExtension = '';
  fileType= '';
  exportType = '';
  includeColumns:ExportColumnInfo[];

  userId: string;
  orgId: string;
  refineryId: string;
  //nodeId: string;
  transformId: string;
  cacheKeyType:CacheKeyType;

  constructor(refineryConfigID:string,nodeId:string,transformerID:string, fileDelimiter: string,fileExtension: string,fileType:string,exportType:string,includeColumns:ExportColumnInfo[],
    userId: string,
    orgId: string,
    refineryId: string,
    //nodeId: string,
    transformId: string,
    cacheKeyType:CacheKeyType) {
    this.refineryConfigID = refineryConfigID;
    this.nodeId = nodeId;
    this.transformerID = transformerID;
    this.fileDelimiter = fileDelimiter;
    this.fileExtension = fileExtension;
    this.fileType = fileType;
    this.exportType = exportType;
    this.includeColumns = includeColumns;
    this.userId = userId;
    this.orgId = orgId;
    this.refineryId = refineryId;
    //this.nodeId = nodeId;
    this.transformId = transformId;
    this.cacheKeyType = cacheKeyType;    
  }
}
export class ExportColumnInfo {
  index: number;
  name: string;
  targetcolumn:string;
  dataType: string;
  description: string;
  isinclude?: boolean;

  constructor(index: number, name: string,targetcolumn:string, dataType: string, description: string, isinclude: boolean) {
    this.index = index;
    this.name = name;
    this.targetcolumn = targetcolumn;
    this.dataType = dataType;
    this.description = description;
    this.isinclude = isinclude;
  }
}
export enum ExportType {
  File = 1,
  Excel,
  Feather
}
export class ExportDataFileResponse {
  file_path = '';
  file_name = '';
  status = 0;
  /** Non-fatal issues that didn't stop the export (e.g. requested columns no longer present
   *  in this node's current output) -- shown to the Analyst as a non-blocking notice, not an
   *  error, since the download already succeeded. */
  warnings?: string[];
}
export class ExportSaveConfigModel {
  fileDelimiter = '';
  fileExtension = '';
  fileType= '';
  isUseSource = true;
  includeColumns:ExportColumnInfo[];

  constructor(fileDelimiter: string,fileExtension: string,fileType:string,isUseSource:boolean,includeColumns:ExportColumnInfo[]) {
    this.fileDelimiter = fileDelimiter;
    this.fileExtension = fileExtension;
    this.fileType = fileType;
    this.isUseSource = isUseSource;
    this.includeColumns = includeColumns;
  }
}